<template>
  <div style="display: flex; flex-direction: column;height: 100%">
    <div class="sub-title"><i class="iconfont icon-guanxitu"></i> 1vN查询</div>
    <div class="main-shadow-box">
      <el-form inline style="padding: 5px 20px;">
        <el-form-item label="人脸库ID">
          <el-input v-model="bucketId" placeholder="请输入人脸库ID进行查询"></el-input>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="timeRange"
            value-format="timestamp"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="load1vN">查 询</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list_1vN">
        <el-table-column prop="id" label="日志ID" width="60"></el-table-column>
        <el-table-column label="服务地址" prop="server" width="155px"></el-table-column>
        <el-table-column label="请求路由" prop="route" width="145px"></el-table-column>
        <el-table-column label="请求IP" prop="caller" width="130px"></el-table-column>
        <el-table-column prop="bucketName" label="人脸库名称" width="90"></el-table-column>
        <el-table-column label="对比类型" width="90px">
          <template v-slot="scope" >
            {{scope.row.route | route_name}}
          </template>
        </el-table-column>
        <el-table-column prop="compareMode" label="对比模式" width="90">
          <template v-slot="s">
            {{s.row.compareMode.replace("模式","")}}
          </template>
        </el-table-column>
        <el-table-column prop="result" label="对比结果">
          <template v-slot="s">
            <span v-if="!s.row.resultTop">{{s.row.result}}</span>
            <div v-else style="display: flex; flex-direction: row; align-items:center">
              <el-image style="width: 100px; height: 100px"
                        :src="resultSrc(s.row.bucket, s.row.resultTop.key)"
                        fit="contain"></el-image>
              <div style="margin-left: 10px">置信度：{{Math.round(s.row.resultTop.match * 100 * 100)/100}}%</div>
            </div>
          </template>
        </el-table-column>
         <el-table-column prop="createTime" label="请求时间" width="140">
          <template v-slot="s">{{s.row.createTime | date_time}}</template>
        </el-table-column>
        <el-table-column prop="image" label="操作" align="center" width="120">
          <template v-slot="s">
            <el-button @click="picView(s.row)">查看详情图</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="text-align: center; "
                     :total="total" :layout="'prev, pager, next, ->, total'"
                     :current-page="page + 1"
                     :page-size="size"
                     @current-change="pageChange"
                     hide-on-single-page
      ></el-pagination>
    </div>

    <el-dialog :visible.sync="visible" title="详情" append-to-body>
      <div style="text-align: center">
        <el-image v-if="pic" style="margin-bottom: 15px;" :src="src(pic)" fit="contain"></el-image>
        <el-table :data="details">
          <el-table-column label="图片" align="center">
            <template v-slot="s">
              <el-image style="width: 100px; height: 100px"
                        :src="resultSrc(pic.bucket, s.row.key)"
                        fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="置信度" align="center">
            <template v-slot="s">
              {{Math.round(s.row.match * 100 * 100)/100}}%
              <i v-if="s.$index === 0"
                 class="el-icon-check" style="font-weight: bold; color:#00b900; font-size: 18px;"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { mapState } from "vuex"
  export default {
    data() {
      return {
        timeRange: '',
        bucketId: null,
        list_1vN: [],
        visible: false,
        pic: null,
        details: [],

        page: 0,
        size: 12,
        total: 0
      };
    },
    computed: {
      ...mapState("bucket", ["list"]),
      queryOpts() {
        return {
          bucket: this.bucketId,
          startTime: this.timeRange[0],
          endTime: this.timeRange[1],
          page: this.page,
          size: this.size
        }
      },
    },
    async beforeRouteEnter(to, from, next) {
      if(Vue.store.state.me === null) {
        next(vm => {
          vm.$router.push('login')
        })
      } else {
        await Vue.store.dispatch("bucket/list");
        next();
      }
    },
    methods: {
      async load1vN(){
        let res = await this.$request(this.$api.record.list1vsN(this.queryOpts));
        this.list_1vN = res.list;
        for (let e of res.list) {
          if(e.result[0]==='['){
            let r = JSON.parse(e.result);
            if(r.length>0){
              e.resultTop = r[0]
            }
          }
        }
        this.total = res.total;

        if(res.total===0){
          this.$message.success("无对应历史信息")
          return;
        }

        for(let log of this.list_1vN){
          log.bucketName = '-';
          for(let bucket of this.list){
            if(log.bucket === bucket.id){
              log.bucketName = bucket.name;
            }
          }
        }
      },
      picView(record){
        this.details = [];

        this.pic = record;
        if(record.resultTop){
          this.details = JSON.parse(record.result)
        }

        this.visible = true;
      },
      src(e) {
        return this.$api.record.image1vsN({ id: e.id });
      },
      resultSrc(bucket, key){
        return this.$api.model.image({bucket, key});
      },
      pageChange(page){
        this.page = page - 1;
        this.load1vN();
      }
    }
  }
</script>
